import { render } from "./TopCategoryLink.vue?vue&type=template&id=1993b86c&scoped=true"
import script from "./TopCategoryLink.vue?vue&type=script&lang=js"
export * from "./TopCategoryLink.vue?vue&type=script&lang=js"

import "./TopCategoryLink.scss?vue&type=style&index=0&id=1993b86c&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1993b86c"]])

export default __exports__